export default __webpack_public_path__ + "images/6227957b5738657365b839319675f13c.png";